module.exports = __webpack_public_path__ + "static/siervos-de62d83d2204b08acad8b1e561a99abd.jpg";